var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/image/on.webp"),"alt":"","srcset":""},on:{"click":function($event){return _vm.change(false)}}}):_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/image/off.webp"),"alt":"","srcset":""},on:{"click":function($event){return _vm.change(true)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }